export default __webpack_public_path__ + "static/media/keyvis_players_right_dt.73885770.png";